export default __webpack_public_path__ + "static/media/big-swap-white.dfbdaaff.svg";